import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "CarpetaBgBlanco",
  "use": "CarpetaBgBlanco-usage",
  "viewBox": "0 0 64 54",
  "content": "<symbol viewBox=\"0 0 64 54\" xmlns=\"http://www.w3.org/2000/svg\" id=\"CarpetaBgBlanco\"><title>CARPETA</title><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M60 13H29a2 2 0 0 1-2-2V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v46a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1V14a1 1 0 0 0-1-1z\" fill=\"#FFF\" /><path d=\"M60 13H29a2 2 0 0 1-2-2V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v46a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1V14a1 1 0 0 0-1-1zm-30-3h31a3 3 0 0 1 3 3v38a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h24a3 3 0 0 1 3 3v7z\" fill=\"#000\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol